var React = require('react');

function IconSecure (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 1.5a9 9 0 019 9.31c-.48-.2-.99-.3-1.5-.3v-.01a7.5 7.5 0 10-6 7.35v1.52A9 9 0 1110.5 1.5zM9.37 12.06l4.31-4.31a.75.75 0 011.15.95l-.09.1-4.83 4.85a.75.75 0 01-.96.1l-.1-.1-2.63-2.62a.75.75 0 01.96-1.15l.1.09 2.1 2.1zM15.75 15H15a1.5 1.5 0 00-1.5 1.5V21a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5v-3.75-.75A1.5 1.5 0 0021 15h-.75v-.74a2.25 2.25 0 00-4.5 0V15zm1.5-.74a.75.75 0 111.5 0V15h-1.5v-.74zM18 19.5a.75.75 0 110-1.5.75.75 0 010 1.5z","fill":"#008D3C"}));
}

IconSecure.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconSecure;

IconSecure.default = IconSecure;
